var prodcat = prodcat || '';
var site = site || '';
var pwr = pwr || '';

(function ($) {
  Drupal.behaviors.sppReviewsV1 = {
    renderRetriesIncremental: 0,
    attach: function (context) {
      var self = this;
      var wrapperUrl = '';
      var signedIn = '';
      var reviewWrapperUrl = '';
      var signedReviewUrl = '';
      if (self.attached) {
        return;
      }
      self.attached = true;
      var pr_products = [];
      var pr_product, query_string, skus, sku_count;
      var $product = $('.js-product-ui', context);
      var product_id = $product.data('product-id');
      var sku_base_id = $product.data('sku-base-id');
      var product = prodcat.data.getProduct(product_id);
      var product_base_id = product.PROD_BASE_ID;
      var page_id = Drupal.settings.power_reviews.page_id || product_base_id;
      var review_display_id = 'pr-reviewdisplay-' + product_base_id + '-' + sku_base_id + '-' + '1' + '-' + new Date().getTime();
      var $review_display = $('.spp-reviews__content', context);
      var image_url = typeof product.skus[0].LARGE_IMAGE === 'object' ? product.skus[0].LARGE_IMAGE[0] : product.skus[0].LARGE_IMAGE;
      var url = encodeURI(product.url);
      var base_url = window.location.protocol + '//' + document.location.hostname;
      var variants = [];
      var drupalPRSettings = Drupal.settings.analytics ? Drupal.settings.analytics.power_reviews_enh_enabled : false;
      var prDisclosureCode = Drupal.settings.power_reviews.disclosure_code;

      if (typeof Drupal.settings.power_reviews !== 'undefined' && typeof Drupal.settings.power_reviews.signed_review_url !== 'undefined') {
        signedReviewUrl = Drupal.settings.power_reviews.signed_review_url;
      }

      wrapperUrl = Drupal.settings.power_reviews.review_wrapper_url;
      signedIn = site.userInfoCookie.getValue('signed_in') - 0 === 1;

      if (signedReviewUrl && signedIn) {
        wrapperUrl = Drupal.settings.power_reviews.review_wrapper_url_signin;
      }

      // Only bind reviews display once.
      if (!$review_display.length) {
        return;
      }

      // Maccosmetics CA FR Config Changes
      var pr_locale = document.location.hostname.search('fr.maccosmetics.ca') !== -1 ? Drupal.settings.power_reviews.locale_fr : Drupal.settings.power_reviews.locale;
      var pr_merchant_id = document.location.hostname.search('fr.maccosmetics.ca') !== -1 ? Drupal.settings.power_reviews.merchant_id_fr : Drupal.settings.power_reviews.merchant_id;
      var locales = $.cookie('LOCALE');

      if (locales && locales !== '') {
        locales = locales.toLowerCase();
        if (typeof Drupal.settings.power_reviews[locales] !== 'undefined' && typeof Drupal.settings.power_reviews[locales]['merchant_id'] !== 'undefined' && typeof Drupal.settings.power_reviews[locales]['locale'] !== 'undefined') {
          pr_merchant_id = Drupal.settings.power_reviews[locales]['merchant_id'];
          pr_locale = Drupal.settings.power_reviews[locales]['locale'];
        }
      }

      if (product.shaded) {
        query_string = '?pr_page_id=' + page_id + '&pr_skuId=SKU' + sku_base_id;
      } else {
        query_string = '?pr_page_id=' + page_id;
      }

      if (!!prDisclosureCode) {
        query_string += '&pr_disclosure_code=' + prDisclosureCode;
      }
      reviewWrapperUrl = (wrapperUrl || '/review/create') + query_string;

      // Add unique snippet identifier to snippet for reference.
      $review_display.attr('id', review_display_id);

      // Initialize product config.
      pr_product = {
        api_key: Drupal.settings.power_reviews.api_key,
        locale: pr_locale,
        merchant_group_id: Drupal.settings.power_reviews.merchant_group_id,
        merchant_id: pr_merchant_id,
        page_id: page_id,
        review_wrapper_url: reviewWrapperUrl,
        structured_data_product_id: 'pr_seo_snippet',
        components: {
          ReviewDisplay: 'pr-reviewdisplay'
        }
      };

      if (Drupal.settings.power_reviews.show_ask_question && !$('#pr-questionsnippet').hasClass('question-processed')) {
        $('#pr-questionsnippet').addClass('question-processed');
        $('.js-pr-ask-tab').removeClass('hidden');

        var pr_product_question = {
          api_key: Drupal.settings.power_reviews.api_key,
          locale: Drupal.settings.power_reviews.locale,
          merchant_group_id: Drupal.settings.power_reviews.merchant_group_id,
          merchant_id: Drupal.settings.power_reviews.merchant_id,
          page_id: page_id,
          review_wrapper_url: reviewWrapperUrl,
          on_render: function (config, data) {
            var question_count = data.question_count;

            if (question_count > 0) {
              $('.pr-ask-question-link').addClass('hidden');
              if (!$('.pr-snippet-qa-answer-link').hasClass('count-rendered')) {
                $('.pr-snippet-qa-answer-link').append(' (' + question_count + ')');
                $('.pr-snippet-qa-answer-link').addClass('count-rendered');
              }
            } else {
              $('.pr-snippet-qa-metrics').addClass('hidden');
            }
            $('.js-pr-spp-ask-snippet').html($('#pr-questionsnippet').html());
            first_time_exec = false;
            // MTA-220 Analytics enhancements for Ask Answer section Starts
            if (drupalPRSettings) {
              // Tracking while start asking a question
              $('#pr-question-form-link').once().on('click', function () {
                if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && $(this).text() !== 'Cancel') {
                  site.track.questionAsk();
                }
              });

              // Tracking sort option in ask and answer section
              $('#pr-qa-sort-by').once().on('change', function () {
                if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
                  var obj = {
                    sort_option: $('option:selected', this).text()
                  };

                  site.track.sortAnswers(obj);
                }
              });

              // Tracking search action in ask and answer section
              $('.pr-qa-search-btn').once().on('click', function () {
                if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
                  var obj = {
                    search_term: $(this).siblings('#pr-query').attr('value')
                  };

                  site.track.questionAskSearch(obj);
                }
              });
            }
          },

          // Tracking while submitting a question
          on_submit: function (config, data) {
            if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && drupalPRSettings) {
              site.track.questionAnswer();
            }
          },
          // MTA-220 Analytics enhancements for Ask Answer section Ends

          on_view_answers_click: function () {
            $('.js-pr-ask-tab', $('.tabs-nav')).click();
            $('html, body').animate({
              'scrollTop': $('#pr-questiondisplay').offset().top
            }, 1000);
            // MTA-220 Tracking while start reading Q & A section
            if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && drupalPRSettings) {
              site.track.questionAsk();
            }
          },
          components: {
            QuestionSnippet: 'pr-questionsnippet',
            QuestionDisplay: 'pr-questiondisplay'
          }
        };

        pr_products.push(pr_product_question);
      }

      // MTA-220 Track thumbs up rating for a review
      $(document).on('click', '.pr-rd-helpful-action .pr-helpful-yes', function () {
        if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && drupalPRSettings) {
          var obj = {
            event_action: 'thumbs up'
          };

          site.track.rateReviews(obj);
        }
      });

      // MTA-220 Track thumbs down  rating for a review
      $(document).on('click', '.pr-rd-helpful-action .pr-helpful-no', function () {
        if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && drupalPRSettings) {
          var obj = {
            event_action: 'thumbs down'
          };

          site.track.rateReviews(obj);
        }
      });

      // MTA-220 Track flagging reviews in review page
      $(document).on('click', '.pr-rd-flag-review-container .pr-underline, .pr-flag-review .pr-flag-review-btn-submit', function () {
        if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && drupalPRSettings) {
          var obj = {
            event_action: 'flag this review'
          };

          site.track.rateReviews(obj);
        }
      });

      // MTA-220 Track thumbs up rating for an answer
      $(document).on('click', '.pr-qa-display-answer-details .pr-helpful-yes', function () {
        if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && drupalPRSettings) {
          var obj = {
            event_action: 'thumbs up'
          };

          site.track.rateAnswers(obj);
        }
      });

      // MTA-220 Track thumbs down  rating for an answer
      $(document).on('click', '.pr-qa-display-answer-details .pr-helpful-no', function () {
        if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && drupalPRSettings) {
          var obj = {
            event_action: 'thumbs down'
          };

          site.track.rateAnswers(obj);
        }
      });

      // MTA-220 Tracking show more answers click
      $(document).on('click', '.pr-qa-display-show-more-questions, .pr-btn-show-more .pr-qa-display-text', function () {
        if (typeof site !== 'undefined' && typeof site.track !== 'undefined' && drupalPRSettings) {
          site.track.showMoreAnswers();
        }
      });

      $('ul.tabs-nav li').on('click', function () {
        var tab_id = $(this).attr('data-tab');

        $('.tabs-content,.spp-reviews__title').hide();
        $('ul.tabs-nav li').removeClass('tab-active');
        $('.' + tab_id).show().removeClass('hidden');
        $(this).addClass('tab-active');
        $('#pr-questiondisplay').removeClass('hidden');
      });
      // On render callback allows us to manipulate the DOM post react app mounting.
      pr_product.on_render = function (config, data) {
        if (config.component === 'ReviewDisplay') {
          $('.pr-review-snapshot-block-cons', $('.pr-review-snapshot-block-container')).append($('.pr-review-snapshot-snippets'));
          $('.pr-review-snapshot-block-pros', $('.pr-review-snapshot-block-container')).append($('.pr-review-snapshot-msq', $('.pr-review-snapshot-msq-container')));
          if (!$('#pr-review-snapshot').hasClass('pr-snapshot-mobile')) {
            $('.pr-rd-review-header-contents', $('.pr-rd-main-header-with-filters')).prepend($('#pr-rd-filter-variant-by'), $('.pr-rd-review-header-sorts'));
          }
        }

        // MTA-220 Analytics enhancements for read/write reviews Starts
        if (drupalPRSettings) {
          // Track sort option in reviews page
          $('#pr-rd-sort-by').once().on('change', function () {
            if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
              var obj = {
                sort_option: $('option:selected', this).text()
              };

              site.track.sortReviews(obj);
            }
          });

          // Track write revew button in reviews section
          $('.pr-snippet-write-review-link').once().on('click', function () {
            if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
              site.track.reviewWriteStart();
            }
          });

          // Track write revew button in reviews section
          $('.js-product-full__rating').once('js-read-reviews').each(function () {
            $(this).on('click', function () {
              if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
                site.track.reviewRead();
              }
            });
          });

          // Tracking search action in review section
          $('.pr-rd-search-reviews-icon-button').once().on('click', function () {
            if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
              var searchTerm = $(this).siblings(':input').attr('value');

              if (searchTerm && searchTerm !== '') {
                var obj = {
                  search_term: searchTerm
                };

                site.track.searchReviews(obj);
              }
            }
          });

          // Track filter option in reviews page
          $('#pr-rd-filter-variant-by').once().on('change', function () {
            if (typeof site !== 'undefined' && typeof site.track !== 'undefined') {
              var obj = {
                sort_option: $('option:selected', this).text()
              };

              site.track.filterReviews(obj);
            }
          });
        }
        // MTA-220 Analytics enhancements for read/write reviews Ends
      };

      // If shaded, add variants.
      if (product.shaded) {
        skus = product.skus;
        sku_count = skus.length;
        for (var s = 0; s < sku_count; s++) {
          if (!skus[s].SHADENAME) {
            continue;
          }
          variants.push({
            'name': skus[s].SHADENAME.toString(),
            'description': skus[s].SHADENAME.toString(),
            'upc': skus[s].UPC_CODE,
            'page_id_variant': skus[s].SKU_ID
          });
        }
      }

      // Product specific data.
      pr_product.product = {
        name: product.PROD_RGN_NAME,
        url: base_url + url,
        image_url: base_url + image_url,
        description: product.DESCRIPTION,
        category_name: product.DEFAULT_CAT_ID,
        upc: product.skus[0].UPC_CODE,
        brand_name: 'MAC',
        price: product.skus[0].PRICE,
        in_stock: (!!product.isShoppable).toString(),
        variants: variants
      };
      pr_products.push(pr_product);

      self.renderReviews(pr_products);
    },
    renderReviews: function(pr_products) {
      var self = this;
      if (pwr === '' && self.renderRetriesIncremental < 10) {
        self.renderRetriesIncremental++;
        setTimeout(function() {
          self.renderReviews(pr_products);
        }, self.renderRetriesIncremental * 100);
      } else {
        // Render the reviews via the app.
        pwr('render', pr_products);
      }
    },
    attached: false
  };
})(jQuery);
